import { PRIVATE, EVERYONE, SPECIFIC } from 'sales-content-partitioning/constants/SharingOptionTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SHARING_OPTION_CONTENT = {
  [PRIVATE]: /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentPartitioning.assignmentPanel.sharingOptions.dontShare"
    }), /*#__PURE__*/_jsx(HelpIcon, {
      tooltipPlacement: "right",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "salesContentPartitioning.assignmentPanel.tooltips.privateWithPartner"
      }),
      marginInlineStart: "200"
    })]
  }),
  [EVERYONE]: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "salesContentPartitioning.assignmentPanel.sharingOptions.shareEveryone"
  }),
  [SPECIFIC]: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "salesContentPartitioning.assignmentPanel.sharingOptions.shareSpecific"
  })
};
const SharingRadioInput = ({
  selectedValue,
  option,
  showLock,
  onChange,
  readOnly
}) => {
  return /*#__PURE__*/_jsx(RadioInput, {
    value: option,
    checked: selectedValue === option,
    name: "sharingOptions",
    onChange: onChange,
    readOnly: readOnly,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [SHARING_OPTION_CONTENT[option], showLock && /*#__PURE__*/_jsx(LockBadge, {})]
    })
  });
};
export default SharingRadioInput;